<template>
  <section class="card">
    <h2 class="section-heading">
      {{ t('employerForm.termInfoForCandidate.title') }}
    </h2>

    <div class="checkbox-group">
      <div class="checkbox-block">
        <label :class="['checkbox-item',{ 'is-invalid': formErrors.has('termInfoForCandidate.nintyDaysTermsAccepted') }]">
          <input type="checkbox" v-model="form.nintyDaysTermsAccepted"
            @change="clearError('termInfoForCandidate.nintyDaysTermsAccepted')" 
          />
          <span>1.</span>
          <span class="policy-text">
            {{ t('employerForm.termInfoForCandidate.nintyDaysTermsAccepted') }}
          </span>
        </label>
        <p class="invalid-feedback" v-if="formErrors.has('termInfoForCandidate.nintyDaysTermsAccepted')">
          {{ t(formErrors.first('termInfoForCandidate.nintyDaysTermsAccepted')) }}
        </p>
      </div>
      <div class="checkbox-block">
        <label :class="['checkbox-item',{ 'is-invalid': formErrors.has('termInfoForCandidate.disabilityLawTermAccepted') }]">
          <input type="checkbox" v-model="form.disabilityLawTermAccepted"
            @change="clearError('termInfoForCandidate.disabilityLawTermAccepted')" 
          />
          <span>2.</span>
          <span class="policy-text">
            {{ t('employerForm.termInfoForCandidate.disabilityLawTermAccepted') }}
          </span>
        </label>
        <p class="invalid-feedback" v-if="formErrors.has('termInfoForCandidate.disabilityLawTermAccepted')">
          {{ t(formErrors.first('termInfoForCandidate.disabilityLawTermAccepted')) }}
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
import Error from '@/utils/Error';
import { reactive, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({})
  },

  formErrors: {
    type: Object,
    required: false,
    default: reactive(new Error({}))
  }
});

const emit = defineEmits([
  'update:modelValue',
  'removeError'
]);

const form = reactive({
  disabilityLawTermAccepted: false,
  nintyDaysTermsAccepted: false,
  ...props.modelValue
});

watch(
  form,
  (val) => emit('update:modelValue', val),
  { deep: true }
);

watch(
  () => props.modelValue,
  (newValue) => {
    Object.assign(form, {
      disabilityLawTermAccepted: false,
      nintyDaysTermsAccepted: false,
      ...newValue
    });
  },
  { deep: true, immediate: true }
);

const clearError = (name) => {
  emit('removeError', name);
};
</script>

<style scoped>
.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.checkbox-block {
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  padding: 10px 14px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
}

.checkbox-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  line-height: 1.5;
}

.policy-text {
  white-space: pre-line;
}
.checkbox-item input[type="checkbox"] {
  width: 20px;
  height: 20px;
  min-width: 20px;
  margin-top: 2px; 
  cursor: pointer;
  accent-color: #2563eb; 
}
</style>